import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/about.scss";

function About() {
  return (
    <main className="about-page">
      <section className="about-page__hero" aria-labelledby="about-title">
        <div className="about-page__hero-copy">
          <p className="about-page__eyebrow">Our point of view</p>
          <h1 id="about-title">
            Made for life.
            <em>Shaped by {siteConfig.brandLine}.</em>
          </h1>
          <p>{siteConfig.description}</p>
          <Link to="/shop">
            Discover the collection <FiArrowRight aria-hidden="true" />
          </Link>
        </div>
        <figure className="about-page__hero-visual">
          <img
            src="/img/campaign/about-awmeadow.png"
            alt={`${siteConfig.displayName} leather tote in an original studio setting`}
          />
          <figcaption>Form, function and the freedom to move.</figcaption>
        </figure>
      </section>

      <section className="about-page__manifesto" aria-labelledby="manifesto-title">
        <p className="about-page__eyebrow">The everyday, reconsidered</p>
        <h2 id="manifesto-title">
          We make bags that belong in real lives—not behind glass.
        </h2>
        <div>
          <p>
            Our designs find their character in contrast: clean lines and soft
            leather, considered details and unforced ease, familiar shapes and
            a distinctly modern attitude.
          </p>
          <p>
            Every piece is designed to be carried often, to gather stories and
            to become more personal with time. Quietly confident, useful and
            always ready for what comes next.
          </p>
        </div>
      </section>

      <section className="about-page__berlin" id="berlin" aria-labelledby="berlin-title">
        <div className="about-page__berlin-index" aria-hidden="true">
          <span>AW</span>
          <span>MEADOW</span>
        </div>
        <div className="about-page__berlin-copy">
          <p className="about-page__eyebrow">The landscape in every detail</p>
          <h2 id="berlin-title">Open, direct and always in motion.</h2>
          <p>
            Open landscapes give us our rhythm. Natural lines sharpen our
            silhouettes, while changing light keeps them relaxed. We design for
            days that change direction without warning—from morning meetings to
            unplanned evenings.
          </p>
          <p>
            That is why practicality is never an afterthought. Straps adjust,
            compartments make sense and proportions feel natural on the body.
          </p>
        </div>
      </section>

      <section className="about-page__craft" id="craft" aria-labelledby="craft-title">
        <div className="about-page__section-heading">
          <p className="about-page__eyebrow">How we design</p>
          <h2 id="craft-title">Character comes from the details.</h2>
        </div>
        <div className="about-page__principles">
          <article>
            <span>01</span>
            <h3>Material first</h3>
            <p>
              We choose expressive leathers and tactile fabrics for their feel,
              resilience and ability to age with individuality.
            </p>
          </article>
          <article>
            <span>02</span>
            <h3>Purpose in every line</h3>
            <p>
              Pockets, closures and straps are resolved alongside the shape, so
              the final object feels instinctive from the first carry.
            </p>
          </article>
          <article>
            <span>03</span>
            <h3>Less, but better</h3>
            <p>
              Rather than decoration for its own sake, we rely on proportion,
              texture and precise construction to create lasting appeal.
            </p>
          </article>
        </div>
      </section>

      <section className="about-page__cta" aria-label="Shop the collection">
        <p>Carry your own story.</p>
        <h2>Find the piece that moves with you.</h2>
        <Link to="/shop">
          Shop all bags <FiArrowRight aria-hidden="true" />
        </Link>
      </section>
    </main>
  );
}

export default About;
